import { Locale, type LocalizedString } from "../Locale.js";
import { ProductOption } from "../ProductOption.js";

export const productOptionNameMap: Record<ProductOption, LocalizedString> = {
	[ProductOption.CakeFilling]: { [Locale.cs]: "Náplň dortu" },
	[ProductOption.CreamColor]: {
		[Locale.cs]: "Barevná šlehačka",
	},
	[ProductOption.CustomerRequirement]: {
		[Locale.cs]: "Požadavek zákazníka",
	},
	[ProductOption.ExtraFruit]: {
		[Locale.cs]: "Ovoce navíc",
	},
	[ProductOption.Figurines]: {
		[Locale.cs]: "Figurky",
	},
	[ProductOption.Filling]: {
		[Locale.cs]: "Náplň",
	},
	[ProductOption.GlutenFreeVariant]: {
		[Locale.cs]: "Bezlepková varianta",
	},
	[ProductOption.Inscription]: {
		[Locale.cs]: "Nápis",
	},
	[ProductOption.Labels]: {
		[Locale.cs]: "Cedulky",
	},
	[ProductOption.LactoseFreeVariant]: {
		[Locale.cs]: "Bezlaktózová varianta",
	},
	[ProductOption.LyingPhoto]: {
		[Locale.cs]: "Jedlý tisk - ležící",
	},
	[ProductOption.Macaroons]: {
		[Locale.cs]: "Makronky",
	},
	[ProductOption.Meringues]: {
		[Locale.cs]: "Zdobení sněhovými pusinkami",
	},
	[ProductOption.Numbers]: {
		[Locale.cs]: "Čokoládové číslo na dort",
	},
	[ProductOption.StandingPhotos]: {
		[Locale.cs]: "Jedlý tisk - stojící",
	},
	[ProductOption.ThemedCupcakes]: {
		[Locale.cs]: "Tematické cupcakes",
	},
	[ProductOption.ThemedMacaroons]: {
		[Locale.cs]: "Tematické makronky",
	},
};
